import {getKlaviyoScript} from '../getKlaviyoScript'

export function initNewsletterFooter() {
	$('[data-newsletter-footer]').once('newsletterFooter').each(function () {
		const $container = $(this)
		const $form = $container.find('.footer-newsletter__form')
		const $message = $container.find('.footer-newsletter__message')

		getKlaviyoScript().then(() => {
			// noinspection JSUnresolvedVariable
			KlaviyoSubscribe.attachToForms($form.get(0), {
				hide_form_on_success: true,
				extra_properties: {
					'$source': 'footer'
				}
			})
		})

		$form.on('klaviyo.subscribe.success klaviyo.subscribe.error', function () {
			$form.hide()
			$message.show()
		})
	})
}